import {
  Component,
  OnInit,
  Inject,
  forwardRef,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { DataEntityEditorBaseComponent } from '../../data-entity-editor-base/data-entity-editor-base.component';
import {
  WorkflowService,
  WorkflowContextService,
  SystemService
} from '../../../../../services';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { CalculatedValueDataEntity } from 'src/app/models/data-entities';
import { ConditionTarget } from 'src/app/components/system/condition-builder/condition-builder.model';

@Component({
    selector: 'wm-calculate-value-data-entity-editor',
    templateUrl: './calculate-value-data-entity-editor.component.html',
    styleUrls: ['./calculate-value-data-entity-editor.component.css'],
    standalone: false
})
export class CalculateValueDataEntityEditorComponent
  extends DataEntityEditorBaseComponent
  implements OnInit {
  @Input() dataEntity: CalculatedValueDataEntity;

  constructor(
    @Inject(forwardRef(() => WorkflowService))
    public _workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    private _context: WorkflowContextService,
    @Inject(forwardRef(() => SystemService)) private _systemSvc: SystemService,
    private changeDetRef: ChangeDetectorRef,
    private _fb: UntypedFormBuilder
  ) {
    super();
  }

  ngOnInit() {
    this.form.addControl(
      'allowEdit',
      this._fb.control(false, [Validators.required])
    );
    this.form.addControl(
      'visibleToUser',
      this._fb.control(false, [Validators.required])
    );
    this.form.addControl(
      'calc-formula',
      this._fb.control('', [Validators.required])
    );
    this.form.addControl(
      'output-format',
      this._fb.control('', [Validators.required])
    );

    if (this.dataEntity && this.dataEntity.allowEditFormula) {
      this.form.addControl(
        'formula',
        this._fb.control('', [Validators.required])
      );
    }

      if (this.dataEntity) {
    this.form.patchValue({
      allowEdit: this.dataEntity.allowEdit,
      visibleToUser: this.dataEntity.visibleToUser,
      'output-format': this.dataEntity.outputFormat
    });
  }

  if (this.form.controls['calc-formula']) {
  this.form.controls['calc-formula'].setValue('done');
}

if (this.form.controls['formula']) {
  this.form.controls['formula'].setValue('done');
}



    if (this.dataEntity) {
      if (this.form.controls['allowEdit']) {
        if (
          this._context.client &&
          (this.dataEntity.isSystemEntity || false)
        ) {
          this.form.controls['allowEdit'].disable();
        } else {
          this.form.controls['allowEdit'].enable();
        }
      }

      if (this.form.controls['output-format']) {
        if (
          this._context.client &&
          (this.dataEntity.isSystemEntity || false)
        ) {
          this.form.controls['output-format'].disable();
        } else {
          this.form.controls['output-format'].enable();
        }
      }

      if (this.form.controls['visibleToUser']) {
        if (
          this._context.client &&
          (!this.dataEntity.allowEditVisibleToUser || false)
        ) {
          this.form.controls['visibleToUser'].disable();
        } else {
          this.form.controls['visibleToUser'].enable();
        }
      }
   

  
 

    }
  }

  updateCriteria(criteria: ConditionTarget[]) {
    this.dataEntity.formulaCriteria = criteria;

    if (this.form.controls['calc-formula']) {
      this.form.controls['calc-formula'].setValue(
        (criteria || []).length > 0 ? 'done' : ''
      );
    }

  //   console.log('After criteria update');
  // console.log('Form Valid:', this.form.valid);
  // console.log('Calc Formula:', this.form.get('calc-formula')?.value);

    this.updated.emit(this.dataEntity);
  }

  // Use => in order to force `this` into being the FeeDataEntityEditorComponent
  getThenLabel = (clause: ConditionTarget): string => {
    if (clause) {
      return clause.value;
    } else {
      return 'needs refactored';
    }
  }
}
